export const NAV = {
  dashboard: "nav-dashboard-link",
  create: "nav-create-link",
  content: "nav-content-link",
  history: "nav-history-link",
  profile: "nav-profile-link",
  admin: "nav-admin-link",
  userButton: "user-profile-button",
  generationsBadge: "generations-badge",
  logoutButton: "logout-button",
  mobileMenuToggle: "mobile-menu-toggle",
};

export const LOGIN = {
  googleSignInButton: "google-signin-button",
  landingHero: "landing-hero",
};

export const DASH = {
  remainingCard: "remaining-generations-card",
  ctaButton: "create-image-cta-button",
  quickStats: "quick-stats-container",
  recentGrid: "recent-generations-grid",
};

export const CREATE = {
  dropzone: "clothing-upload-dropzone",
  input: "clothing-upload-input",
  removeImage: "remove-uploaded-image",
  presetSample: "preset-sample-button",
  modeSingle: "mode-single-button",
  modeSeries: "mode-series-button",
  gender: "gender-select",
  age: "age-select",
  pose: "pose-select",
  background: "background-select",
  ar_1_1: "aspect-ratio-1-1",
  ar_4_5: "aspect-ratio-4-5",
  ar_9_16: "aspect-ratio-9-16",
  ar_16_9: "aspect-ratio-16-9",
  customPrompt: "custom-prompt-input",
  generate: "generate-image-button",
  generateSeries: "generate-series-button",
  loader: "generation-loader",
  original: "result-original-image",
  generated: "result-generated-image",
  download: "download-result-button",
  seriesGallery: "series-gallery",
  seriesItem: "series-item",
  downloadAll: "download-all-button",
  chooseModelSection: "choose-model-section",
  faceRefTab: "face-reference-tab",
  savedModelsTab: "saved-models-tab",
  faceRefCard: "face-reference-card",
  faceRefRandom: "face-reference-random",
  savedModelCard: "saved-model-card",
  saveModelButton: "save-model-button",
};

export const HIST = {
  search: "history-search-input",
  itemCard: "history-item-card",
  download: "download-history-item-button",
  retry: "retry-history-item-button",
};

export const PROFILE = {
  info: "google-user-info",
  gauge: "usage-stats-gauge",
};

export const ADMIN = {
  stats: "admin-stats-overview",
  usersTable: "admin-users-table",
  search: "admin-search-input",
  enableSwitch: "user-enable-switch",
  limitInput: "user-limit-input",
  save: "save-limits-button",
  resetOverride: "reset-override-button",
  defaultLimit: "default-limit-input",
  saveDefault: "save-default-limit-button",
  faceRefSection: "admin-face-references-section",
  faceRefBootstrapAll: "admin-face-references-bootstrap-all",
  faceRefBootstrapForce: "admin-face-references-bootstrap-force",
  faceRefBootstrapCard: "admin-face-reference-card",
  faceRefBootstrapOne: "admin-face-reference-bootstrap-one",
  faceRefProgress: "admin-face-references-progress",
};
